import { IconApi } from '@components/icons/api';
import { IconCompany } from '@components/icons/company';
import { IconIntegrations } from '@components/icons/integrations';
import { IconLock } from '@components/icons/lock';
import { IconPerson } from '@components/icons/person';
import { IconPortal } from '@components/icons/portal';
import { IconSSO } from '@components/icons/sso';
import { IconStatistics } from '@components/icons/statistics';
import { IconTeam } from '@components/icons/team';
import { getScopedTranslate } from '@locale/translate';

import { MyDetails } from './pages/account/my-details';
import { MySecurity } from './pages/account/security';
import { UserApps } from './pages/account/user-apps';
import { IntegrationDetail } from './pages/integrations/detail';
import { Integrations } from './pages/integrations/list';
import { EmailDomain } from './pages/organization/email-domain';
import { General } from './pages/organization/general';
import { MCPServers } from './pages/organization/mcp-servers';
import { MCPServerDetail } from './pages/organization/mcp-servers/detail';
import { Security } from './pages/organization/security';
import { TeamList } from './pages/organization/user-list';
import { PortalDetails } from './pages/portals/portal-layout';
import { PortalStatistics } from './pages/portals/portal-statistics';
import { Portals } from './pages/portals/portals';
import { BillingPage } from './pages/subscription/billing';
import { Plans } from './pages/subscription/plans';

const locale = {
  en: {
    settings: 'Settings',
    users: 'Users',
    companySecurity: 'Organization security',
    profileSettings: 'Profile settings',
    accountSecuritySettings: 'Account security settings',
    apiSettings: 'API settings',
    integrations: 'Integrations',
    portals: 'Portals',
    statistics: 'Statistics',
    mcpServers: 'MCP Servers',
  },
};

const { t } = getScopedTranslate(locale);

export const settingsPrefix = '/settings/';

export const settingsRoutes = [
  {
    commandPaletteName: t('settings'),
    commandPaletteIcon: IconCompany,
    name: 'settingsGeneral',
    path: 'general',
    page: <General />,
  },
  {
    name: 'settingsEmailDomain',
    path: 'email-domain',
    page: <EmailDomain />,
  },
  {
    name: 'subscriptionPlans',
    path: 'plans',
    page: <Plans />,
  },
  {
    name: 'subscriptionBilling',
    path: 'billing/*',
    page: <BillingPage />,
  },
  {
    commandPaletteName: t('users'),
    commandPaletteIcon: IconTeam,
    name: 'settingsUsers',
    path: 'users/*',
    page: <TeamList />,
  },
  {
    commandPaletteName: t('companySecurity'),
    commandPaletteIcon: IconSSO,
    name: 'settingsOrganizationSecurity',
    path: 'organization-security',
    page: <Security />,
  },
  {
    commandPaletteName: t('profileSettings'),
    commandPaletteIcon: IconPerson,
    name: 'settingsProfile',
    path: 'profile',
    page: <MyDetails />,
  },
  {
    commandPaletteName: t('accountSecuritySettings'),
    commandPaletteIcon: IconLock,
    name: 'settingsAccountSecurity',
    path: 'account-security',
    page: <MySecurity />,
  },
  {
    commandPaletteName: t('apiSettings'),
    commandPaletteIcon: IconApi,
    name: 'settingsApi',
    path: 'api',
    page: <UserApps />,
  },
  {
    commandPaletteName: t('integrations'),
    commandPaletteIcon: IconIntegrations,
    name: 'integrations',
    path: 'integrations',
    page: <Integrations />,
  },
  {
    name: 'integrationDetail',
    path: 'integration/:integrationId/*',
    page: <IntegrationDetail />,
  },
  {
    commandPaletteName: t('portals'),
    commandPaletteIcon: IconPortal,
    name: 'portals',
    path: 'portals',
    page: <Portals />,
  },
  {
    commandPaletteName: t('statistics'),
    commandPaletteIcon: IconStatistics,
    name: 'portalStatistics',
    path: 'portals-statistics',
    page: <PortalStatistics />,
  },
  {
    name: 'portalDetail',
    path: 'portals/:portalId/*',
    page: <PortalDetails />,
  },
  {
    name: 'mcpServers',
    path: 'mcp-servers',
    page: <MCPServers />,
  },
  {
    name: 'mcpServerDetail',
    path: 'mcp-servers/:serverId',
    page: <MCPServerDetail />,
  },
] as const;
